import Star from './Star.Icon';
import "./ReviewStars.scss"
import React from 'react';
interface Props {
    stars: number;
    setStars: (stars: number) => void;
    readOnly?: boolean;
    size?: ReviewStarsSize;
}
export enum ReviewStarsSize {
    Small = "sizeSmall",
    Default = "sizeMedium",
    Medium = "sizeMedium",
    Large = "sizeLarge"
  }
  
function StarView(props:{readOnly?:boolean, star:number, setStars:(stars:number)=>void}) {
    const className = "Star star" + props.star;
    if (props.readOnly) {
        return <div className={className}><Star/></div>
    }
    return <button onClick={()=>{props.setStars(props.star)}} className={className}><Star/></button>
}

export class ReviewStars extends React.Component<Props> {
    static Size = ReviewStarsSize;

    render() {
    const {stars, setStars, readOnly, size} = this.props;
    const className = size ? "ReviewStars " + size : "ReviewStars " + ReviewStarsSize.Default;
 
    
    return  <div className={className + (readOnly ? " readOnly ":" selectable ") + " Stars"+stars }>


    <div className={"starGroup OneStar"}>
    <StarView readOnly={readOnly} star={1} setStars={setStars}/>

    
            <div className={"starGroup TwoStars"}>
            <StarView readOnly={readOnly} star={2} setStars={setStars}/>

            <div className={"starGroup ThreeStars"}>
            <StarView readOnly={readOnly} star={3} setStars={setStars}/>

            <div className={"starGroup FourStars"}>
            <StarView readOnly={readOnly} star={4} setStars={setStars}/>
            <div className={"starGroup FiveStars"}>
            <StarView readOnly={readOnly} star={5} setStars={setStars}/>

            </div>
            </div>
            </div>
            </div>
            </div>



        </div>;

    }
}
   